import {
	USERS_SUCCESS,
	USERS_FAILURE,
	USERS_LOADING,
	USERS_UPDATING,
	USERS_UPDATING_FAILURE,
	USERS_UPDATING_SUCCESS,
	RESET_USERS_UPDATING_SUCCESS,
	USERS_DELETING,
	USERS_DELETING_SUCCESS,
	USERS_DELETING_FAILURE,
	DELETE_TEAM_SUCCESS,
	RESET_USERS_DELETING_SUCCESS,
	ME_LOADING,
	ME_SUCCESS,
	ME_FAILURE,
	JOINING_TEAM,
	JOIN_TEAM_SUCCESS,
	JOIN_TEAM_FAILURE,
	CREATE_TEAM_SUCCESS,
	AWARDS_LOADING,
	AWARDS_LOADING_FAILURE,
	AWARDS_LOADING_SUCCESS,
	UPDATE_SELECTED_TEAM,
	TOGGLING_FAVORITE_TEAM_SUCCESS,
	TOGGLING_FAVORITE_TEAM_FAILURE,
	LEAVING_TEAM,
	LEAVE_TEAM_FAILURE,
	LEAVE_TEAM_SUCCESS,
	NEW_TEAM_VISITED,
	EDIT_TEAM_SUCCESS,
	SENDING_FEEDBACK,
	SEND_FEEDBACK_SUCCESS,
	SEND_FEEDBACK_FAILURE,
	RESET_SEND_FEEDBACK_SUCCESS,
	ACCEPTING_EULA,
	ACCEPT_EULA_FAILURE,
	ACCEPT_EULA_SUCCESS,
	RESET_ACCEPT_EULA_SUCCESS,
	TOGGLE_ALL_NOTIFICATIONS,
	TOGGLE_ALL_NOTIFICATIONS_FAILURE,
	TOGGLE_ALL_NOTIFICATIONS_SUCCESS,
	RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS,
	TOGGLE_PERSONAL_NOTIFICATIONS,
	TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE,
	TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS,
	RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS,
	UPDATE_SEASON_SUCCESS,
	START_SEASON_SUCCESS,
	END_SEASON_SUCCESS,
	END_SEASON,
	TEAM_SEASONS_LOADING,
	TEAM_SEASONS_SUCCESS,
	TEAM_SEASONS_FAILURE,
	TOUR_FAILURE,
	TOUR_SAVING,
	TOUR_SUCCESS,
	RESET_TOUR_SUCCESS,
	SETUP_SETTINGS_TOUR,
	SETUP_TEAMHOME_TOUR,
	CLEANUP_SETTINGS_TOUR,
	CLEANUP_TEAMHOME_TOUR,
	DELETING_TOURS,
	DELETE_TOURS_SUCCESS,
	RESET_DELETE_TOURS_SUCCESS,
	DELETE_TOURS_FAILURE,
} from 'redux/reduxConstants';
import { TeamUsers } from 'redux/models/teamUsers';
import { Team } from 'redux/models/team';
import { EditSeason } from 'redux/models/editSeason';

export interface UserState {
	usersLoading: boolean;
	usersDeleting: boolean;
	usersDeletingSuccess: boolean;
	meLoading: boolean;
	awardsLoading: boolean;
	joiningTeam: boolean;
	leavingTeam: boolean;
	leaveTeamSuccess: boolean | undefined;
	userId: string;
	userName: string;
	userEmail: string;
	hasAcceptedTerms: boolean;
	teams: Team[];
	selectedTeam?: Team;
	users: TeamUsers[];
	userAwards: any;
	joinedNewTeam: boolean;
	usersUpdating: boolean;
	usersUpdatingSuccess: boolean;
	feedbackSending: boolean;
	feedbackSendingSuccess: boolean;
	eulaAccepting: boolean;
	eulaAcceptingSuccess: boolean;
	togglingPersonalNotifications: boolean;
	togglingPersonalNotificationsSuccess: boolean;
	togglingAllNotifications: boolean;
	togglingAllNotificationsSuccess: boolean;
	tourSaving: boolean;
	tourSuccess: boolean;
	seasonsLoading: boolean;
	tours: string[];
	tourModifiedVariables: {
		selectedTeamIsAdmin: boolean;
		currentSeasonId: boolean;
		selectedTeamIsLocked: boolean;
		selectedTeamAdminOnlyPosts: boolean;
	};
	deletingTours: boolean;
	deletingToursSuccess: boolean;
	error: string;
}

const userState: UserState = {
	usersLoading: false,
	usersDeleting: false,
	usersDeletingSuccess: false,
	meLoading: false,
	awardsLoading: false,
	joiningTeam: false,
	usersUpdating: false,
	usersUpdatingSuccess: false,
	leavingTeam: false,
	leaveTeamSuccess: undefined,
	userId: '',
	userName: '',
	userEmail: '',
	hasAcceptedTerms: true,
	teams: [],
	selectedTeam: undefined,
	userAwards: [],
	users: [],
	joinedNewTeam: false,
	feedbackSending: false,
	feedbackSendingSuccess: false,
	eulaAccepting: false,
	eulaAcceptingSuccess: false,
	togglingPersonalNotifications: false,
	togglingPersonalNotificationsSuccess: false,
	togglingAllNotifications: false,
	togglingAllNotificationsSuccess: false,
	seasonsLoading: false,
	tourSaving: false,
	tourSuccess: false,
	tourModifiedVariables: {
		selectedTeamIsAdmin: false,
		currentSeasonId: false,
		selectedTeamAdminOnlyPosts: false,
		selectedTeamIsLocked: false
	},
	tours: [],
	deletingTours: false,
	deletingToursSuccess: false,
	error: '',
};

const users = (state: UserState = userState, action: any) => {
	switch (action.type) {
		case USERS_LOADING:
			let usersState = { ...state };
			usersState.usersLoading = true;
			return usersState;

		case USERS_SUCCESS:
			let usersSuccessState = { ...state };
			usersSuccessState.usersLoading = false;
			usersSuccessState.users = action.users;
			return usersSuccessState;

		case USERS_FAILURE:
			let usersFailureState = { ...state };
			usersFailureState.usersLoading = false;
			usersFailureState.error = action.error;
			return usersFailureState;

		case ME_LOADING:
			let meLoadingState = { ...state };
			meLoadingState.meLoading = true;
			return meLoadingState;

		case ME_SUCCESS:
			let meSuccessState = { ...state };
			meSuccessState.meLoading = false;
			meSuccessState.userId = action.userTeams.userId;
			meSuccessState.userName = action.userTeams.userName;
			meSuccessState.userEmail = action.userTeams.userEmail;
			meSuccessState.hasAcceptedTerms = action.userTeams.hasAcceptedTerms;
			meSuccessState.teams = action.userTeams.teams || [];
			meSuccessState.tours = action.userTeams.tours;
			return meSuccessState;

		case ME_FAILURE:
			let meFailureState = { ...state };
			meFailureState.meLoading = false;
			meFailureState.error = action.error;
			return meFailureState;

		case JOINING_TEAM:
			let joinTeamState = { ...state };
			joinTeamState.joiningTeam = true;
			return joinTeamState;

		case JOIN_TEAM_SUCCESS:
			let joinTeamSuccessState = { ...state };
			joinTeamSuccessState.joiningTeam = false;
			joinTeamSuccessState.joinedNewTeam = true;

			if (action.userTeams.teams && action.userTeams.teams.length > 0) {
				joinTeamSuccessState.teams = [...state.teams, ...action.userTeams.teams];
				joinTeamSuccessState.teams.sort(function (a, b) {
					var nameA = a.teamName.toUpperCase(); // ignore upper and lowercase
					var nameB = b.teamName.toUpperCase(); // ignore upper and lowercase
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}

					return 0;
				});
			}
			return joinTeamSuccessState;

		case JOIN_TEAM_FAILURE:
			let joinTeamFailureState = { ...state };
			joinTeamFailureState.joiningTeam = false;
			joinTeamFailureState.joinedNewTeam = false;
			joinTeamFailureState.error = action.error;
			return joinTeamFailureState;

		case CREATE_TEAM_SUCCESS:
			let createTeamSuccess = { ...state };
			if (action.userTeams.teams && action.userTeams.teams.length > 0) {
				createTeamSuccess.teams = [...state.teams, ...action.userTeams.teams];
				createTeamSuccess.selectedTeam = action.userTeams.teams[0];
			}
			return createTeamSuccess;

		case EDIT_TEAM_SUCCESS:
			let editTeamSuccessState = { ...state };
			if (editTeamSuccessState.selectedTeam && action.userTeams.teams && action.userTeams.teams.length > 0) {
				let updatedTeam = action.userTeams.teams[0];
				let selectedTeam = {
					...editTeamSuccessState.selectedTeam,
					teamName: updatedTeam.teamName,
					isPrivate: updatedTeam.isPrivate,
					isAdmin: updatedTeam.isAdmin,
					isLocked: updatedTeam.isLocked,
					hideLeaderboard: updatedTeam.hideLeaderboard,
					adminOnlyPosts: updatedTeam.adminOnlyPosts,
				} as Team;
				editTeamSuccessState.selectedTeam = selectedTeam;
				editTeamSuccessState.teams = editTeamSuccessState.teams.map((team: Team) => {
					return team.teamId === selectedTeam.teamId ? selectedTeam : team;
				});
			}
			return editTeamSuccessState;

		case AWARDS_LOADING:
			let awardsLoadingState = { ...state };
			awardsLoadingState.awardsLoading = true;
			return awardsLoadingState;

		case AWARDS_LOADING_SUCCESS:
			let awardsLoadingSuccessState = { ...state };
			awardsLoadingSuccessState.awardsLoading = false;
			awardsLoadingSuccessState.userAwards = action.userTokens;
			return awardsLoadingSuccessState;

		case AWARDS_LOADING_FAILURE:
			let awardsLoadingFailureState = { ...state };
			awardsLoadingFailureState.awardsLoading = false;
			awardsLoadingFailureState.error = action.error;
			return awardsLoadingFailureState;

		case LEAVING_TEAM:
			let leavingTeamState = { ...state };
			leavingTeamState.leaveTeamSuccess = undefined;
			leavingTeamState.leavingTeam = true;

			return leavingTeamState;

		case LEAVE_TEAM_SUCCESS:
			let leaveTeamSuccessState = { ...state };
			leaveTeamSuccessState.leavingTeam = false;
			leaveTeamSuccessState.leaveTeamSuccess = true;

			if (leaveTeamSuccessState.selectedTeam) {
				const remainingTeams = leaveTeamSuccessState.teams.filter(team => team.teamId !== action.leftTeamId);
				leaveTeamSuccessState.teams = remainingTeams;
				leaveTeamSuccessState.selectedTeam = remainingTeams && remainingTeams.length > 0 ? remainingTeams[0] : undefined;
			}

			return leaveTeamSuccessState;
		case LEAVE_TEAM_FAILURE:
			let leaveTeamFailureState = { ...state };
			leaveTeamFailureState.leavingTeam = false;
			leaveTeamFailureState.leaveTeamSuccess = false;
			leaveTeamFailureState.error = action.error;

			return leaveTeamFailureState;
		case UPDATE_SELECTED_TEAM:
			let updateSelectedTeamState = { ...state };
			let selectedTeam = undefined;

			if (!action.teamId) {
				for (const team of updateSelectedTeamState.teams) {
					if (team.favorite) {
						selectedTeam = team;
						break;
					}
				}

				if (selectedTeam === undefined) {
					selectedTeam = updateSelectedTeamState.teams[0];
				}
			} else {
				selectedTeam = updateSelectedTeamState.teams.find((team: Team) => team.teamId === action.teamId);
			}

			updateSelectedTeamState.selectedTeam = selectedTeam;
			return updateSelectedTeamState;

		case TOGGLING_FAVORITE_TEAM_SUCCESS:
			let togglingFavoritTeamSuccessState = { ...state };
			const teams = state.teams.map(team => {
				if (team.teamId === action.team.teamId) {
					return action.team;
				} else {
					return team;
				}
			});
			togglingFavoritTeamSuccessState.teams = teams;
			return togglingFavoritTeamSuccessState;

		case TOGGLING_FAVORITE_TEAM_FAILURE:
			let togglingFavoritTeamFailureState = { ...state };
			togglingFavoritTeamFailureState.error = action.error;
			return togglingFavoritTeamFailureState;

		case NEW_TEAM_VISITED:
			let newTeamVisitedState = { ...state };
			newTeamVisitedState.joinedNewTeam = false;
			return newTeamVisitedState;

		case USERS_UPDATING:
			let usersUpdatingState = { ...state };
			usersUpdatingState.usersUpdating = true;
			return usersUpdatingState;

		case USERS_UPDATING_SUCCESS:
			let usersUpdatingSuccessState = { ...state };
			const updatedUsersFromAPI: Record<string, TeamUsers> = {};

			action.users.forEach((user: TeamUsers) => {
				updatedUsersFromAPI[user.userId] = user;
			});

			const updatedStateUsers = usersUpdatingSuccessState.users.map((user: TeamUsers) => {
				if (updatedUsersFromAPI[user.userId]) {
					return updatedUsersFromAPI[user.userId];
				} else {
					return user;
				}
			});

			usersUpdatingSuccessState.users = updatedStateUsers;
			usersUpdatingSuccessState.usersUpdating = false;
			usersUpdatingSuccessState.usersUpdatingSuccess = true;
			return usersUpdatingSuccessState;

		case USERS_UPDATING_FAILURE:
			let usersUpdatingFailureState = { ...state };
			usersUpdatingFailureState.usersUpdating = false;
			usersUpdatingFailureState.error = action.error;
			return usersUpdatingFailureState;

		case RESET_USERS_UPDATING_SUCCESS:
			let resetUsersUpdatingSuccessState = { ...state };
			resetUsersUpdatingSuccessState.usersUpdatingSuccess = false;
			return resetUsersUpdatingSuccessState;

		case USERS_DELETING:
			let usersDeletingState = { ...state };
			usersDeletingState.usersDeleting = true;
			return usersDeletingState;

		case USERS_DELETING_SUCCESS:
			let usersDeletingSuccessState = { ...state };
			const usersToDelete: Record<string, string> = {};

			action.userIds.forEach((userId: string) => {
				usersToDelete[userId] = '';
			});

			const updatedUsers = usersDeletingSuccessState.users.filter((user: TeamUsers) => !(user.userId in usersToDelete));
			usersDeletingSuccessState.users = updatedUsers;
			usersDeletingSuccessState.usersDeleting = false;
			usersDeletingSuccessState.usersDeletingSuccess = true;
			return usersDeletingSuccessState;

		case USERS_DELETING_FAILURE:
			let usersDeletingFailureState = { ...state };
			usersDeletingFailureState.usersDeleting = false;
			usersDeletingFailureState.error = action.error;
			return usersDeletingFailureState;

		case RESET_USERS_DELETING_SUCCESS:
			let resetUsersDeletingSuccessState = { ...state };
			resetUsersDeletingSuccessState.usersDeleting = false;
			return resetUsersDeletingSuccessState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case DELETE_TEAM_SUCCESS:
			let deleteTeamSuccessState = { ...state };
			const updatedTeams = deleteTeamSuccessState.teams.filter((team: Team) => team.teamId !== action.teamId);
			deleteTeamSuccessState.teams = updatedTeams;

			if (updatedTeams.length === 0) {
				// what do we do if there are no teams left?
			}

			deleteTeamSuccessState.selectedTeam = updatedTeams[0];
			return deleteTeamSuccessState;

		case SENDING_FEEDBACK:
			let sendingFeedbackState = { ...state };
			sendingFeedbackState.feedbackSending = true;
			return sendingFeedbackState;

		case SEND_FEEDBACK_SUCCESS:
			let sendFeedbackSuccessState = { ...state };
			sendFeedbackSuccessState.feedbackSending = false;
			sendFeedbackSuccessState.feedbackSendingSuccess = true;
			return sendFeedbackSuccessState;

		case SEND_FEEDBACK_FAILURE:
			let sendFeedbackFailureState = { ...state };
			sendFeedbackFailureState.feedbackSending = false;
			sendFeedbackFailureState.error = action.error;
			return sendFeedbackFailureState;

		case ACCEPTING_EULA:
			let acceptingEulaState = { ...state };
			acceptingEulaState.eulaAccepting = true;
			return acceptingEulaState;

		case ACCEPT_EULA_SUCCESS:
			let acceptingEulaSuccessState = { ...state };
			acceptingEulaSuccessState.eulaAccepting = false;
			acceptingEulaSuccessState.eulaAcceptingSuccess = true;
			acceptingEulaSuccessState.hasAcceptedTerms = true;
			return acceptingEulaSuccessState;

		case ACCEPT_EULA_FAILURE:
			let acceptingEulaFailureState = { ...state };
			acceptingEulaFailureState.eulaAccepting = false;
			acceptingEulaFailureState.error = action.error;
			return acceptingEulaFailureState;

		case RESET_ACCEPT_EULA_SUCCESS:
			let resetAcceptEulaSuccessState = { ...state };
			resetAcceptEulaSuccessState.eulaAcceptingSuccess = false;
			return resetAcceptEulaSuccessState;

		case RESET_SEND_FEEDBACK_SUCCESS:
			let resetSendFeedbackFailureState = { ...state };
			resetSendFeedbackFailureState.feedbackSendingSuccess = false;
			return resetSendFeedbackFailureState;

		case TOGGLE_ALL_NOTIFICATIONS:
			let togglingAllNotificationsState = { ...state };
			togglingAllNotificationsState.togglingAllNotifications = true;

			if (togglingAllNotificationsState.selectedTeam) {
				const selectedTeam = { ...togglingAllNotificationsState.selectedTeam };
				selectedTeam.allNotifications = !selectedTeam.allNotifications;
				togglingAllNotificationsState.selectedTeam = selectedTeam;
			}
			return togglingAllNotificationsState;

		case TOGGLE_ALL_NOTIFICATIONS_SUCCESS:
			let togglingAllNotificationsSuccessState = { ...state };
			togglingAllNotificationsSuccessState.togglingAllNotifications = false;
			togglingAllNotificationsSuccessState.togglingAllNotificationsSuccess = true;
			togglingAllNotificationsSuccessState.teams = togglingAllNotificationsSuccessState.teams.map(team => {
				if (team.teamId === action.team.teamId) {
					team.allNotifications = !team.allNotifications;
				}
				return team;
			});
			return togglingAllNotificationsSuccessState;

		case TOGGLE_ALL_NOTIFICATIONS_FAILURE:
			let togglingAllNotificationsFailureState = { ...state };
			togglingAllNotificationsFailureState.togglingAllNotifications = false;

			if (togglingAllNotificationsFailureState.selectedTeam) {
				const selectedTeam = { ...togglingAllNotificationsFailureState.selectedTeam };
				selectedTeam.allNotifications = !selectedTeam.allNotifications;
				togglingAllNotificationsFailureState.selectedTeam = selectedTeam;
			}

			togglingAllNotificationsFailureState.error = action.error;
			return togglingAllNotificationsFailureState;

		case RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS:
			let resetTogglingAllNotificationsSuccessState = { ...state };
			resetTogglingAllNotificationsSuccessState.togglingAllNotificationsSuccess = false;
			return resetTogglingAllNotificationsSuccessState;

		case TOGGLE_PERSONAL_NOTIFICATIONS:
			let togglingPersonalNotificationsState = { ...state };
			togglingPersonalNotificationsState.togglingPersonalNotifications = true;

			if (togglingPersonalNotificationsState.selectedTeam) {
				const selectedTeam = { ...togglingPersonalNotificationsState.selectedTeam };
				selectedTeam.personalNotifications = !selectedTeam.personalNotifications;
				togglingPersonalNotificationsState.selectedTeam = selectedTeam;
			}

			return togglingPersonalNotificationsState;

		case TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS:
			let togglingPersonalNotificationsSuccessState = { ...state };
			togglingPersonalNotificationsSuccessState.togglingPersonalNotifications = false;
			togglingPersonalNotificationsSuccessState.togglingPersonalNotificationsSuccess = true;
			togglingPersonalNotificationsSuccessState.teams = togglingPersonalNotificationsSuccessState.teams.map(team => {
				if (team.teamId === action.team.teamId) {
					team.personalNotifications = !team.personalNotifications;
				}
				return team;
			});
			return togglingPersonalNotificationsSuccessState;

		case TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE:
			let togglingPersonalNotificationsFailureState = { ...state };
			togglingPersonalNotificationsFailureState.togglingPersonalNotifications = false;

			if (togglingPersonalNotificationsFailureState.selectedTeam) {
				const selectedTeam = { ...togglingPersonalNotificationsFailureState.selectedTeam };
				selectedTeam.personalNotifications = !selectedTeam.personalNotifications;
				togglingPersonalNotificationsFailureState.selectedTeam = selectedTeam;
			}

			togglingPersonalNotificationsFailureState.error = action.error;
			return togglingPersonalNotificationsFailureState;

		case RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS:
			let resetTogglingPersonalNotificationsSuccessState = { ...state };
			resetTogglingPersonalNotificationsSuccessState.togglingPersonalNotificationsSuccess = false;
			return resetTogglingPersonalNotificationsSuccessState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case END_SEASON:
			let endSeasonState = { ...state };

			if (endSeasonState.selectedTeam) {
				const selectedTeam = { ...endSeasonState.selectedTeam };
				selectedTeam.currentSeasonName = action.season.seasonName;
				endSeasonState.selectedTeam = selectedTeam;
			}

			endSeasonState.teams = endSeasonState.teams.map((team: Team) => {
				if (team.teamId === action.season.teamId) {
					team.currentSeasonName = action.season.seasonName;
				}

				return team;
			});

			return endSeasonState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case UPDATE_SEASON_SUCCESS:
			let updateSeasonSuccessState = { ...state };
			const updatedSeason: EditSeason = action.season;

			if (updateSeasonSuccessState.selectedTeam) {
				const selectedTeam = { ...updateSeasonSuccessState.selectedTeam };
				selectedTeam.currentSeasonName = updatedSeason.seasonName;
				updateSeasonSuccessState.selectedTeam = selectedTeam;
			}

			updateSeasonSuccessState.teams = updateSeasonSuccessState.teams.map((team: Team) => {
				if (team.teamId === updatedSeason.teamId) {
					team.currentSeasonName = updatedSeason.seasonName;
				}

				return team;
			});

			return updateSeasonSuccessState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case START_SEASON_SUCCESS:
			let startSeasonSuccessState = { ...state };

			if (startSeasonSuccessState.selectedTeam) {
				const selectedTeam = { ...startSeasonSuccessState.selectedTeam };
				selectedTeam.currentSeasonName = action.season.seasonName;
				selectedTeam.currentSeasonId = action.season.seasonId;
				selectedTeam.isLocked = false;
				startSeasonSuccessState.selectedTeam = selectedTeam;
			}

			startSeasonSuccessState.teams = startSeasonSuccessState.teams.map((team: Team) => {
				if (team.teamId === action.season.teamId) {
					team.currentSeasonName = action.season.seasonName;
					team.currentSeasonId = action.season.seasonId;
					team.isLocked = false;
				}

				return team;
			});

			return startSeasonSuccessState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case END_SEASON_SUCCESS:
			let endSeasonSuccessState = { ...state };

			if (endSeasonSuccessState.selectedTeam) {
				const selectedTeam = { ...endSeasonSuccessState.selectedTeam };
				selectedTeam.previousSeasonName = selectedTeam.currentSeasonName;
				selectedTeam.previousSeasonEndDate = new Date().toLocaleDateString();
				selectedTeam.currentSeasonName = '';
				selectedTeam.currentSeasonId = '';
				selectedTeam.isLocked = true;
				endSeasonSuccessState.selectedTeam = selectedTeam;
			}

			endSeasonSuccessState.teams = endSeasonSuccessState.teams.map((team: Team) => {
				if (team.teamId === action.teamId) {
					team.currentSeasonName = '';
					team.currentSeasonId = '';
					team.isLocked = true;
				}

				return team;
			});

			return endSeasonSuccessState;

		case TEAM_SEASONS_LOADING:
			let seasonsLoadingState = { ...state };
			seasonsLoadingState.seasonsLoading = true;
			return seasonsLoadingState;

		case TEAM_SEASONS_SUCCESS:
			let seasonsSuccessState = { ...state };

			seasonsSuccessState.teams = seasonsSuccessState.teams.map((team: Team) => {
				if (action.seasons.length > 0) {
					if (team.teamId === action.seasons[0].teamId) {
						team.seasons = action.seasons;
					}
				} else {
					if (team.teamId === seasonsSuccessState.selectedTeam?.teamId) {
						team.seasons = [];
					}
				}

				return team;
			});

			seasonsSuccessState.error = '';
			return seasonsSuccessState;

		case TEAM_SEASONS_FAILURE:
			let seasonFailureState = { ...state };
			seasonFailureState.error = action.error;
			return seasonFailureState;

		case TOUR_SUCCESS:
			let tourSuccessState = { ...state };
			tourSuccessState.tourSaving = false;
			tourSuccessState.tourSuccess = true;
			tourSuccessState.tours = [...tourSuccessState.tours, action.tourName];
			return tourSuccessState;

		case TOUR_FAILURE:
			let tourFailureState = { ...state };
			tourFailureState.tourSaving = false;
			tourFailureState.error = action.error;

			return tourFailureState;

		case TOUR_SAVING:
			let tourSavingState = { ...state };
			tourSavingState.tourSaving = true;

			return tourSavingState;

		case RESET_TOUR_SUCCESS:
			let resetTourSuccessState = { ...state };
			resetTourSuccessState.tourSuccess = false;

			return resetTourSuccessState;

		case SETUP_TEAMHOME_TOUR:
			let setupTeamHomeTourState = { ...state };

			if (setupTeamHomeTourState.selectedTeam && setupTeamHomeTourState.selectedTeam.isLocked) {
				setupTeamHomeTourState.selectedTeam.isLocked = false;
				setupTeamHomeTourState.tourModifiedVariables['selectedTeamIsLocked'] = true;
			}

			if (setupTeamHomeTourState.selectedTeam && setupTeamHomeTourState.selectedTeam.adminOnlyPosts) {
				setupTeamHomeTourState.selectedTeam.adminOnlyPosts = false;
				setupTeamHomeTourState.tourModifiedVariables['selectedTeamAdminOnlyPosts'] = true;
			}

			return setupTeamHomeTourState;

		case CLEANUP_TEAMHOME_TOUR:
			let cleanupTeamHomeTourState = { ...state };

			if (cleanupTeamHomeTourState.selectedTeam && cleanupTeamHomeTourState.tourModifiedVariables['selectedTeamIsLocked']) {
				cleanupTeamHomeTourState.selectedTeam.isLocked = !cleanupTeamHomeTourState.selectedTeam.isLocked;
				cleanupTeamHomeTourState.tourModifiedVariables['selectedTeamIsLocked'] = false;
			}
			if (cleanupTeamHomeTourState.selectedTeam && cleanupTeamHomeTourState.tourModifiedVariables['selectedTeamAdminOnlyPosts']) {
				cleanupTeamHomeTourState.selectedTeam.adminOnlyPosts = !cleanupTeamHomeTourState.selectedTeam.adminOnlyPosts;
				cleanupTeamHomeTourState.tourModifiedVariables['selectedTeamAdminOnlyPosts'] = false;
			}

			return cleanupTeamHomeTourState;

		case SETUP_SETTINGS_TOUR:
			let setupSettingsTourState = { ...state };
			if (setupSettingsTourState.selectedTeam && !setupSettingsTourState.selectedTeam.currentSeasonId) {
				setupSettingsTourState.tourModifiedVariables['currentSeasonId'] = true;
				setupSettingsTourState.selectedTeam.currentSeasonId = 'tourtestingid';
			}

			if (setupSettingsTourState.selectedTeam && !setupSettingsTourState.selectedTeam.isAdmin) {
				setupSettingsTourState.tourModifiedVariables['selectedTeamIsAdmin'] = true;
				setupSettingsTourState.selectedTeam.isAdmin = true;
			}

			return setupSettingsTourState;

		case CLEANUP_SETTINGS_TOUR:
			let cleanupSettingsTourState = { ...state };

			if (cleanupSettingsTourState.selectedTeam && cleanupSettingsTourState.tourModifiedVariables['currentSeasonId']) {
				cleanupSettingsTourState.selectedTeam.currentSeasonId = '';
				cleanupSettingsTourState.tourModifiedVariables['currentSeasonId'] = false;
			}

			if (cleanupSettingsTourState.selectedTeam && cleanupSettingsTourState.tourModifiedVariables['selectedTeamIsAdmin']) {
				cleanupSettingsTourState.selectedTeam.isAdmin = !cleanupSettingsTourState.selectedTeam.isAdmin;
				cleanupSettingsTourState.tourModifiedVariables['selectedTeamIsAdmin'] = false;
			}
			
			return cleanupSettingsTourState;

		case DELETING_TOURS:
			let deletingToursState = { ...state };
			deletingToursState.deletingTours = true;

			return deletingToursState;

		case DELETE_TOURS_SUCCESS:
			let deletingToursSuccessState = { ...state };
			deletingToursSuccessState.deletingTours = false;
			deletingToursSuccessState.deletingToursSuccess = true;

			return deletingToursSuccessState;

		case DELETE_TOURS_FAILURE:
			let deletingToursFailureState = { ...state };
			deletingToursFailureState.deletingTours = false;
			deletingToursFailureState.error = action.error;

			return deletingToursFailureState;

		case RESET_DELETE_TOURS_SUCCESS:
			let resetDeleteToursSuccessState = { ...state };
			resetDeleteToursSuccessState.deletingToursSuccess = false;

			return resetDeleteToursSuccessState;
		default:
			return state;
	}
};

export default users;
